import { render, staticRenderFns } from "./ContactsTwitter.vue?vue&type=template&id=6a8d862f&scoped=true&"
import script from "./ContactsTwitter.vue?vue&type=script&lang=js&"
export * from "./ContactsTwitter.vue?vue&type=script&lang=js&"
import style0 from "./ContactsTwitter.vue?vue&type=style&index=0&id=6a8d862f&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8d862f",
  null
  
)

export default component.exports